<template>
  <b-modal
    id="modalDeleteAccountStatement"
    centered
    title="Delete Account Statement"
    title-class="font-18"
    size="md"
    @hide="reset"
  >
    <p class="text-center">Tem certeza que deseja remover o lançamento com ID?</p>

  
    <b-form-group label="ID do account statement" invalid-feedback="Este campo é obrigatório">
      <b-form-input
        v-model="statementId"
        type="number"
        placeholder="Digite o ID do account statement"
        required
        :state="isIdValid === null ? null : isIdValid ? true : false"
      ></b-form-input>
    </b-form-group>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="danger" @click="deleteStatement">Excluir</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import operationsService from '@services/resources/OperationsService';

const accountStatement = operationsService.build();

export default {
  name: 'modalDeleteAccountStatement',
  data() {
    return {
      statementId: null, 
      isIdValid: null, 
    };
  },
  methods: {
    async deleteStatement() {
    
      if (!this.statementId) {
        this.isIdValid = false;
        this.$bvToast.toast('Por favor, insira um ID válido.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
        return;
      }

      try {
       
        await accountStatement.delete(`account-statement/${this.statementId}`);

        this.$bvToast.toast('Removido com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalDeleteAccountStatement');
        this.$emit('deleted');
      } catch (error) {
          let message = 'Erro ao remover AccountStatement';

          if (
            error.response &&
            typeof error.response.data === 'string'
          ) {
            const parsed = JSON.parse(error.response.data);

            if (parsed.message) {
              if (parsed.message === 'Account not found') {
                message = 'Account não encontrado';
              } else {
                message = parsed.message;
              }
            }
          }

          this.$bvToast.toast(message, {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          });
        }
    },
    reset() {
      this.$emit('reset');
      this.isIdValid = null; 
    },
  },
};
</script>
